export default __webpack_public_path__ + "media/src/shared/images/logo/sns/facebook-7ae81356ad959519dc11d9fe01b958bd.png";